import { InvoiceReportTable } from './invoice-report-table'


export const InvoiceReportsPageV2 = () => {
    return <InvoiceReportTable />
}
